import i18n from '../VueI18n'

const fixos = ['VTCC', 'VTSC', 'VICC', 'VISC']

const sitio = [
	{
		label: i18n.t('totalVolumeWithBark'),
		value: 'volumeTotalComCasca',
		acronimo: 'VTCC',
		latex: 'VTCC',
		unidade: '(m³/ha)',
		enum: 'VolumeTotalComCasca',
	},
	{
		label: i18n.t('maximumHBD'),
		value: 'dapMaximo',
		acronimo: 'DAP_MAX',
		latex: 'Dap_{max}',
		unidade: '(cm)',
		enum: 'DAPMaximo',
	},
	{
		label: i18n.t('dominantHeight'),
		value: 'alturaDominante',
		acronimo: 'H_DOM',
		latex: 'HDom',
		unidade: '(m)',
		enum: 'AlturaDominante',
	},
	{
		label: i18n.t('volumeIndividualComCasca'),
		value: 'volumeIndividualComCasca',
		acronimo: 'VICC',
		latex: 'VICC',
		unidade: '(m³/fuste)',
		enum: 'VolumeIndividualComCasca',
	},
	{
		label: i18n.t('diametroMedioQuadratico'),
		value: 'diametroMedioQuadratico',
		acronimo: 'DG',
		latex: 'DG',
		unidade: '(cm)',
		enum: 'DiametroMedioQuadratico',
	},
	// {
	//   label: "Incremento Médio Anual do VTCC",
	//   value: "incrementoMedioAnualComCasca",
	//   acronimo: "IMA_VTCC",
	//   latex: "IMA_{VTCC}",
	//   unidade: "(m^3/ha/ano)",
	//   enum: "IncrementoMedioAnualComCasca",
	// },
	{
		label: i18n.t('basalArea'),
		value: 'areaBasal',
		acronimo: 'AB',
		latex: 'AB',
		unidade: '(m³/ha)',
		enum: 'AreaBasal',
	},
]

var prognose = sitio.concat([
	{
		label: i18n.t('totalVolumeWithOutBark'),
		value: 'volumeTotalSemCasca',
		acronimo: 'VTSC',
		latex: 'VTSC',
		unidade: '(m³/ha)',
		enum: 'VolumeTotalSemCasca',
	},
	// {
	//   label: "Incremento médio anual sem casca",
	//   value: "incrementoMedioAnualSemCasca",
	//   acronimo: "IMA_VTSC",
	//   latex: "IMA_{VTSC}",
	//   unidade: "(m³/ha/ano)",
	//   enum: "IncrementoMedioAnualSemCasca",
	// },
	{
		label: i18n.t('averageHBD'),
		value: 'dapMedio',
		acronimo: 'DAP_MED',
		latex: 'Dap_{med}',
		unidade: '(cm)',
		enum: 'DAPMedio',
	},
	{
		label: i18n.t('minimumHBD'),
		value: 'dapMinimo',
		acronimo: 'DAP_MIN',
		latex: 'Dap_{min}',
		unidade: '(cm)',
		enum: 'DAPMinimo',
	},
	{
		label: i18n.t('alturaTotalMaxima'),
		value: 'alturaTotalMaxima',
		acronimo: 'HT_MAX',
		latex: 'HTMax',
		unidade: '(m)',
		enum: 'AlturaTotalMaxima',
	},
	{
		label: i18n.t('alturaTotalMedia'),
		value: 'alturaTotalMedia',
		acronimo: 'HT_MED',
		latex: 'HTMed',
		unidade: '(m)',
		enum: 'AlturaTotalMedia',
	},
	{
		label: i18n.t('alturaTotalMinima'),
		value: 'alturaTotalMinima',
		acronimo: 'HT_MIN',
		latex: 'HTMin',
		unidade: '(m)',
		enum: 'AlturaTotalMinima',
	},
	{
		label: i18n.t('stemNumber'),
		value: 'numeroDeFustes',
		acronimo: 'N_FUSTES',
		latex: 'Nfustes',
		unidade: '(un./ha)',
		enum: 'NumeroDeFustes',
	},
	{
		label: i18n.t('volumeIndividualSemCasca'),
		value: 'volumeIndividualSemCasca',
		acronimo: 'VISC',
		latex: 'VISC',
		unidade: '(m³/fuste)',
		enum: 'VolumeIndividualSemCasca',
	},
	// {
	//   label: "Número de Fustes Úteis",
	//   value: "numeroDeFustesUteis",
	//   acronimo: "NfustesUteis",
	//   latex: "NfustesUteis",
	//   unidade: "(un./ha)",
	//   enum: "NumeroDeFustesUteis",
	// },
	// {
	//   label: "Número de Fustes Perdidos",
	//   value: "numeroDeFustesPerdidos",
	//   acronimo: "NfustesPerdidos",
	//   latex: "NfustesPerdidos",
	//   unidade: "(un./ha)",
	//   enum: "NumeroDeFustesPerdidos",
	// },
	{
		label: i18n.t('proporcaoFustesUteis'),
		value: 'proporcaoDeFustes',
		acronimo: 'PF_UTEIS',
		latex: 'PFÚteis',
		unidade: '(%)',
		enum: 'ProporcaoDeFustes',
	},
	// {
	//   label: "Proporção de Fustes Perdidos",
	//   value: "proporcaoDeFustesPerdidos",
	//   acronimo: "PFPerdas",
	//   latex: "PFPerdas",
	//   unidade: "(%)",
	//   enum: "ProporcaoDeFustesPerdidos",
	// },
	// {
	//   label: "Volume total de mortas com casca",
	//   value: "volumeTotalDeMortasComCasca",
	//   acronimo: "VTCCMortas",
	//   latex: "VTCCMortas",
	//   unidade: "(un./ha)",
	//   enum: "VolumeTotalDeMortasComCasca",
	// },
	// {
	//   label: "Volume total de mortas sem casca",
	//   value: "volumeTotalDeMortasSemCasca",
	//   acronimo: "VTSCMortas",
	//   latex: "VTSCMortas",
	//   unidade: "(un./ha)",
	//   enum: "VolumeTotalDeMortasSemCasca",
	// },
])

// console.log(fixos.indexOf("VTCC"))

const opcoesFixas = prognose.filter((f) => fixos.includes(f.acronimo))
const opcoesOrdemImportancia = opcoesFixas.sort((a, b) =>
	fixos.indexOf(a.acronimo) > fixos.indexOf(b.acronimo) ? 1 : -1,
)
const opcoesOrdenadasAlfabetica = prognose
	.filter((f) => !fixos.includes(f.acronimo))
	.sort((a, b) => (a.acronimo > b.acronimo[0] ? 1 : -1))
prognose = opcoesOrdemImportancia.concat(opcoesOrdenadasAlfabetica)
export { prognose, sitio }
